import { getLocale, setLocale } from '../i18n';
import { store } from '../state/store';
import type { WidgetConfig } from '../types';

const DEFAULT_WIDGET_LOCALE: WidgetConfig['language'] = 'he';
const HEBREW_CHARACTER_PATTERN = /[\u0590-\u05FF]/;

export function resolveWidgetLocale(
  configLanguage?: string | null,
): WidgetConfig['language'] {
  const candidate = configLanguage
    ?? store.getState().config.language
    ?? getLocale()
    ?? DEFAULT_WIDGET_LOCALE;

  return candidate === 'en' ? 'en' : 'he';
}

export function resolveSpeechLocale(
  text: string,
  configLanguage?: string | null,
): WidgetConfig['language'] {
  return HEBREW_CHARACTER_PATTERN.test(text) ? 'he' : resolveWidgetLocale(configLanguage);
}

export function syncI18nLocale(
  configLanguage?: string | null,
): WidgetConfig['language'] {
  const locale = resolveWidgetLocale(configLanguage);
  if (getLocale() !== locale) {
    setLocale(locale);
  }
  return locale;
}
